// extracted by mini-css-extract-plugin
export default {"container":"Leaderboard_container__Zlz7N","select":"Leaderboard_select__ULBxp","header":"Leaderboard_header__YX7Lc","nthCol":"Leaderboard_nthCol__7kl2o"};